const {v4: uuidv4} = require('uuid');

export function createGUID(){
    return  uuidv4().toUpperCase()
}

export function isCitizenId(id: any) {
    if (id == null || id.length !== 13 || !/^[0-9]\d+$/.test(id)) {
        return false;
    }
    if (id[0] === 0 || (id[1] === 0 && id[2] === 0)) {
        return false;
    }
    let i, sum: number;
    for ((i = 0), (sum = 0); i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i);
    }
    let check = (11 - sum % 11) % 10;
    return check === parseInt(id.charAt(12));
}

export function isMobileNumber(number: any) {
    if (number === null || number.length !== 10) {
        return false;
    }

    if (number[0] === '0') {
        const re = /^[0-9\b]+$/;
        return re.test(number)
    } else return false;
}